import { Card, CardContent, CardHeader, CardTitle } from './ui/card'
import { Button } from './ui/button'
import { Badge } from './ui/badge'
import { X, Calendar, Clock, Share2, Download } from 'lucide-react'

const AnnouncementModal = ({ announcement, isOpen, onClose }) => {
  if (!isOpen || !announcement) return null

  const getTypeBadge = (type) => {
    const variants = { important:"destructive", update:"default", news:"secondary", info:"outline" }
    return variants[type] || "outline"
  }

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({ title: announcement.title, text: announcement.excerpt, url: window.location.href })
    } else {
      navigator.clipboard.writeText(window.location.href)
      alert('Link panoya kopyalandı!')
    }
  }

  const handleDownload = () => {
    alert('PDF indirme özelliği yakında eklenecek!')
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <Card className="relative max-w-3xl w-full max-h-[90vh] overflow-hidden">
        {/* Yapışkan başlık */}
        <CardHeader className="border-b sticky top-0 bg-white/90 backdrop-blur z-10">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <Badge variant={getTypeBadge(announcement.type)}>{announcement.category}</Badge>
                <span className="text-sm text-gray-500">{announcement.readTime}</span>
              </div>
              <CardTitle className="text-2xl leading-tight">{announcement.title}</CardTitle>
              <div className="flex items-center text-sm text-gray-600 gap-4 mt-1">
                <div className="flex items-center gap-1"><Calendar size={14} />{announcement.date}</div>
                <div className="flex items-center gap-1"><Clock size={14} />Yayınlanma: 09:30</div>
              </div>
            </div>
            <div className="flex items-center gap-2 ml-4">
              <Button variant="outline" size="sm" onClick={handleShare}><Share2 size={16} className="mr-1" />Paylaş</Button>
              <Button variant="outline" size="sm" onClick={handleDownload}><Download size={16} className="mr-1" />PDF</Button>
              <Button variant="ghost" size="sm" onClick={onClose}><X size={20} /></Button>
            </div>
          </div>
        </CardHeader>

        <CardContent className="p-6 overflow-y-auto">
          <div className="prose max-w-none">
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">{announcement.excerpt}</p>
            <div className="space-y-4">
              <h3 className="text-xl font-semibold text-gray-900">Detaylı Açıklama</h3>
              <p className="text-gray-700 leading-relaxed">
                Bu duyuru kapsamında, antrepo gümrük işlemlerinde yaşanan son gelişmeler ve müşterilerimizi ilgilendiren önemli değişiklikler hakkında bilgi veriyoruz.
              </p>
              <h4 className="text-lg font-semibold text-gray-900 mt-6">Önemli Noktalar</h4>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Yeni mevzuat değişiklikleri 1 Nisan 2024 tarihinde yürürlüğe girecektir</li>
                <li>Mevcut işlemleriniz bu değişikliklerden etkilenmeyecektir</li>
                <li>Yeni başvurular için güncellenmiş formlar kullanılmalıdır</li>
                <li>Geçiş süreci için 30 günlük ek süre tanınmıştır</li>
              </ul>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-6">
                <h5 className="font-semibold text-blue-900 mb-2">İletişim</h5>
                <p className="text-blue-800 text-sm">
                  Sorular için: <strong>antrepo@capitaltrans.com.tr</strong> veya <strong>+90 551 865 01 50</strong>
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default AnnouncementModal
